import React, { PureComponent, ReactNode } from 'react';
import { TimedAnnotation } from '@fenderdigital/api-definitions/play';

interface VideoLowerThirdProps {
  player: any; // TODO type
  lowerThird: TimedAnnotation[];
}

interface VideoLowerThirdState {
  hintTitle: string;
  hintCaption: string;
}

class VideoLowerThird extends PureComponent<VideoLowerThirdProps, VideoLowerThirdState> {
  private hintIndex = -1;
  constructor(props: VideoLowerThirdProps) {
    super(props);
    this.state = {
      hintTitle: '',
      hintCaption: '',
    };
    this.onPlayerProgress = this.onPlayerProgress.bind(this);
    this.onPlayerSeek = this.onPlayerSeek.bind(this);
  }

  componentDidMount(): void {
    const { player } = this.props;
    player.on('progress', this.onPlayerProgress);
    player.on('seek', this.onPlayerSeek);
  }

  onPlayerProgress(): void {
    const { lowerThird, player } = this.props;
    const { hintTitle: renderedTitle } = this.state;
    const currentTime = Math.round(player.video.time);

    lowerThird.forEach((hint, i) => {
      const { title, caption } = hint;
      const { 'start-time': startTime, 'end-time': endTime } = hint;
      if (currentTime >= startTime && currentTime <= endTime && !renderedTitle) {
        this.hintIndex = i;
        this.setState({ hintTitle: title, hintCaption: caption });
      } else if (currentTime > endTime && this.hintIndex === i) {
        this.hintIndex = -1;
        this.setState({ hintTitle: '', hintCaption: '' });
      }
    });
  }

  onPlayerSeek(): void {
    this.setState({ hintTitle: '', hintCaption: '' });
  }

  render(): ReactNode {
    const { lowerThird, player } = this.props;
    const { hintTitle, hintCaption } = this.state;
    if (!Array.isArray(lowerThird) || lowerThird.length === 0 || !player) {
      return null;
    }

    return (
      <div className="lower-third flex items-center w-100 h3 db absolute absolute left-0 bottom-0">
        <div className="flex flex-row white">
          <div className={`futura-heavy ${hintTitle ? 'bg-dark-gray' : ''} pv2 pl4 pr2`}>
            {hintTitle}
          </div>
          <div className="source-sans pv2 pl3" style={{ whiteSpace: 'pre' }}>
            {hintCaption}
          </div>
        </div>
      </div>
    );
  }
}

export default VideoLowerThird;
